import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-sales-phone-register-manual-imei-instructions',
  templateUrl: './sales-phone-register-manual-imei-instructions.component.html',
  styles: [
  ]
})
export class SalesPhoneRegisterManualImeiInstructionsComponent {
  visible = true;
  @Output() step = new EventEmitter();

  onIntroduceIMEI() {
    this.step.emit('general-instructions');
  }

  onHide(){
    this.step.emit('general-instructions');
  }

}
